import CloseIcon from "@mui/icons-material/CloseRounded";
import { DialogTitle, Divider, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import ReportNotFoundOrAccessForbidden from "./ReportNotFoundOrAccessForbidden";

const ReportNotFoundOrAccessForbiddenPage = () => {
  const navigate = useNavigate();
  return (
    <Stack sx={{ flex: 1 }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">Report Not Found</Typography>
        <IconButton onClick={() => navigate(`..`)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <ReportNotFoundOrAccessForbidden />
    </Stack>
  );
};

export default ReportNotFoundOrAccessForbiddenPage;
